import { createReducer, on } from '@ngrx/store';

import * as fromConnectToken from './connect-token.actions';

export const connectTokenFeatureKey = 'connect-token';

export interface ConnectTokenState {
  token: string | null;
}

export const initialState: ConnectTokenState = {
  token: null,
};

export const reducer = createReducer(
  initialState,
  on(fromConnectToken.initConnectTokenStateSuccess, (_, { token }) => ({
    token,
  })),
  on(fromConnectToken.resetConnectToken, () => ({
    token: null,
  })),
);
